import React, { useState } from 'react';
import { useParams, withRouter } from 'react-router-dom';
import DF from 'DisplayFramework';
import {
  Badge,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Popover,
  Row,
  Spin,
  Steps,
  Tabs,
  Typography,
  message,
  notification,
} from 'antd';
import FormInput from 'components/FormInput';
import { useForm } from 'antd/lib/form/Form';
import TaxSelect from 'components/TaxSelect';
import UtinaCard from 'components/UtinaCard';
import {
  objectParValueToString,
  objectLabelToString,
  shouldUpdateCompare,
  dateToString,
} from 'utils/utils2';
import AssetUpload from 'components/AssetUpload';
import ParListSelectWithLabelInValue from 'components/ParListSelectWithLabelInValue';
import InputCurrency from 'components/InputCurrency';
import ThirdPartyInput from 'components/ThirdPartyInput';
import Button from 'components/Button';
import Title from 'components/Title';
import { getProcTaskInit, getTaskStepEntity } from 'services/workflow';
import { useQuery } from 'react-query';
import { request } from 'utils/request';
import { API_URLS } from 'utils/config';
import { assetCatalogToAsset } from 'pages/ProposalV3/PropDetail/assetCatalogToAsset';
import _, { isNil, sumBy } from 'lodash';
import { getThirdPartyAuthorizationListByTpid } from 'services/thirdParty';
import getEnvValue from 'utils/getEnvValue';
import {
  AssetRVCriteria,
  AssetUseCriteria,
  FilteringCriteria,
  getOfferDetailByOfferId,
  getprOfferListByPrcodeAndMgid,
  prFilteringCriteria,
} from 'services/pricing';
import moment from 'moment';
import { getRounding, toCurrency, toRate } from 'utils/utils';
import Asset from './Asset';

import { ExclamationCircleFilled, CloseOutlined } from '@ant-design/icons';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import FinancialScheduleModal from 'components/FinancialScheduleModal';
import ScheduleButton from 'components/ScheduleButton';
import Value from 'components/Value';
import ParListSelect from 'components/ParListSelect';
import ModalControllerNV from 'components/ModalControllerNV';
import ButtonOperation from 'components/ButtonOperation';
import ConElemPrefinStepModal from 'pages/ProposalV3/PropDetail/components/ConElemPrefinStepModal';
import DataGrid from 'components/DataGrid';
import { ConElemPrefinStepRequest } from 'services/proposal';
import * as finEngine from 'services/finEngine';

const { confirm } = Modal;
const { Text } = Typography;
const { Step } = Steps;
const { TabPane } = Tabs;

const UsedCarFin = (props: any) => {
  const [form] = useForm();

  const [task, setTask] = useState<any>();
  const [offer, setOffer] = useState<any>(null);
  const [tpAuth, setTpAuth] = useState<any>();
  const [requestToSend, setRequestToSend] = useState<any>(null);

  const [open, setOpen] = useState(0);

  const [loading, setLoading] = useState<any>(false);

  const [tpAuthDetail, settpAuthDetail] = useState<any>(null);
  const [prefinmethod, setPrefinmethod] = useState('');

  const [processTerminated, setProcessTerminated] = useState<any>(false);

  const [requestedamount, setRequestedamount] = useState<number>();
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [finElement, setFinElement] = useState<any>();

  const { id } = useParams<{
    id: string;
  }>();

  const getProposalId = () => {
    const idProp = id;
    if (isNil(idProp)) {
      return;
    }
    return Number(idProp);
  };

  const contractId = getProposalId();

  const { data, isError } = useQuery(
    [
      'getProcTaskInit',
      {
        entity: 'THIRDPARTY',
        entityid: 0,
        funcode: 'TpAuthorizationUse' ?? '',
        action: '',
        prcode: '',
      },
    ],
    () =>
      getProcTaskInit({
        entity: 'THIRDPARTY',
        entityid: Number(localStorage.getItem('tpid')) ?? 0,
        funcode: 'TpAuthorizationUse' ?? '',
        action: '',
        prcode: '',
      }).then((result) => {
        if (result.list.length > 0) {
          setTask(result.list[0]);
          const task: any = result.list[0];
          getTaskStepEntity({
            entity: 'THIRDPARTY',
            entityid: Number(localStorage.getItem('tpid')) ?? 0,
            taskid: task.taskid ?? 0,
          }).then((res) => {
            return res.list || [];
          });
        }
      }),
    {
      staleTime: 5000,
    }
  );

  const getFilterList = (assets: any[]): prFilteringCriteria => {
    let assetList = assets;

    let assetUseCriteriaList: Array<AssetUseCriteria> = [];
    let assetRVCriteriaList: Array<AssetRVCriteria> = [];
    let offerCriteriaList: Array<FilteringCriteria> = [];
    let ret: prFilteringCriteria;

    offerCriteriaList.push({
      critcode: 'PROPORIGIN',
      critvalue: form?.getFieldValue('ctproporigin') ?? '',
    });

    offerCriteriaList.push({
      critcode: 'DEALRATING',
      critvalue: form?.getFieldValue('ctdealerrating') ?? '',
    });

    offerCriteriaList.push({
      critcode: 'OFFER',
      critvalue: form?.getFieldValue('offerid') ?? '0',
    });
    offerCriteriaList.push({
      critcode: 'NASSETS',
      critvalue: form?.getFieldValue('assets')?.length ?? '0',
    });

    const duration = form
      ?.getFieldValue(['elements', 'FIN'])
      ?.filter(
        (e: any) => e.cteid === form?.getFieldValue('selectedElement')
      )[0]?.cteduration;

    offerCriteriaList.push({
      critcode: 'DURATION',
      critvalue: duration ?? 48,
    });

    const invest = sumBy(form?.getFieldValue('assets'), 'assetnetamount');

    offerCriteriaList.push({
      critcode: 'INVEST',
      critvalue: String(invest) ?? '0',
    });

    //PROPORIGIN

    offerCriteriaList.push({
      critcode: 'PRCODE',
      critvalue: form?.getFieldValue('flagmasterfacility')
        ? form?.getFieldValue('mfprcode')
        : form?.getFieldValue('prcode') ?? '',
    });
    offerCriteriaList.push({
      critcode: 'TPTYPE',
      critvalue: form.getFieldValue('client')?.tptype ?? '',
    });
    offerCriteriaList.push({
      critcode: 'NETWORK',
      critvalue: form.getFieldValue('ctnetworkcode') ?? '',
    });
    offerCriteriaList.push({
      critcode: 'CLIRATING',
      critvalue: form.getFieldValue('client')?.tpsalestatus ?? '',
    });

    offerCriteriaList.push({
      critcode: 'ASSETCLASS',
      critvalue: 'UC' ?? '',
    });

    assetList?.forEach((a: any) => {
      assetRVCriteriaList.push({
        catalogid: a.catalogid,
        assetid: a.assetid,
        assetsegment: a.assetsegment,
        assetfamily: a.assetfamily,
        assettype: a.assettype,
        assetcategory: a.assetcategory,
        assetmodel: a.assetmodel,
        assetbrand: a.assetbrand,
        assetbrandmodel: a.assetbrandmodel,
        assetnetamount: a.assetnetamount,
        assetfinamount: a.assetfinamount,
        assetvariant: a.assetvariant,
        // assetclass :a.assetclass,
      });

      offerCriteriaList.push({
        critcode: 'ASSETFAM',
        critvalue: a.assetfamily,
      });
      offerCriteriaList.push({ critcode: 'ASSETTYPE', critvalue: a.assettype });
      offerCriteriaList.push({
        critcode: 'ASSETCAT',
        critvalue: a.assetcategory,
      });

      offerCriteriaList.push({
        critcode: 'FLAGUSED',
        critvalue: a.flagused ?? '',
      });

      offerCriteriaList.push({
        critcode: 'ASSETCLASS',
        critvalue: 'UC' ?? '',
      });

      a.power != null ??
        offerCriteriaList.push({ critcode: 'POWER', critvalue: a.power ?? '' });
      // additional attributes :
      a.entityAddAttributList?.forEach((e: any) => {
        e.attstringvalue !== null
          ? offerCriteriaList.push({
              critcode: e.attcode,
              critvalue: e.attstringvalue,
            })
          : e.attnumericvalue !== null ??
            offerCriteriaList.push({
              critcode: e.attcode,
              critvalue: e.attnumericvalue,
            });
      });

      if (getEnvValue('FLAG_APPLY_ASSET_USE')) {
        a.assetusereqList?.forEach((u: any) => {
          assetUseCriteriaList.push({
            assetfamily: a.assetfamily,
            assettype: a.assettype,
            assetcategory: a.assetcategory,
            catalogid: a.catalogid ?? '',
            attcode: u.attcode ?? '',
            attvalue: u.usevalue ?? '',
          });
        });
      }
    });

    ret = {
      prcode: form?.getFieldValue('flagmasterfacility')
        ? form?.getFieldValue('mfprcode')
        : form?.getFieldValue('prcode') ?? '',
      tpid: form.getFieldValue('client')?.tpid ?? 0,
      tpidbroker: form.getFieldValue('broker')?.tpid ?? 0,
      tpidmanufacturer:
        assetList && assetList.length > 0
          ? assetList![0]?.tpidmanufacturer ?? 0
          : 0,
      assetUseCriteria: assetUseCriteriaList,
      assetRVCriteria: assetRVCriteriaList,
      offerCriteria: offerCriteriaList,
      flagApplyAssetUse: getEnvValue('FLAG_APPLY_ASSET_USE'),
      flagApplyAttributesExtendDurationValues: true,
      flagApplyAttributesExtendFirstRentalValues: true,
      flagApplyAttributesExtendRVValues: true,
      flagApplyAttributesExtendRateValues: true,
      flagApplyExtendDurationValues: true,
      flagApplyExtendFirstRentalValues: true,
      flagApplyExtendRVValues: true,
      flagApplyExtendRateValues: true,
    };
    return ret;
  };

  const {
    data: ThirdPartyAuthorization,
    refetch,
    isFetching,
  } = useQuery(
    [
      'getThirdPartyAuthorizationListByTpid',
      { tpid: Number(localStorage.getItem('tpid')) },
    ],
    () =>
      getThirdPartyAuthorizationListByTpid({
        tpid: Number(localStorage.getItem('tpid')),
      }).then(async (res) => {
        if (res?.list?.length > 0) {
          form.setFieldValue('authid', res.list[0].authid);
          setTpAuth(res.list[0]);
          await getprOfferListByPrcodeAndMgid({
            filters: getFilterList([]),
          }).then((result) => {
            if (result?.list?.length > 0) {
              const filteredOffer = result.list[0];
              const filteredAuthDetailList: any[] =
                res?.list[0]?.authDetail.filter(
                  (authdetail: any) =>
                    authdetail.offerid === filteredOffer.offerid
                );
              // setTpAuthDetail(filteredAuthDetailList);

              if (filteredAuthDetailList?.length > 0) {
                const authDetail: any = filteredAuthDetailList[0];
                settpAuthDetail(authDetail);

                if (open === 0) {
                  setOpen(1);
                }
              }
            }
          });
        }
        return res.list || [];
      })
  );

  const onChange = (value: number) => {
    if (currentStep !== 2) {
      setCurrentStep(value);
    }
  };

  const columnsPrefinSteps = [
    {
      dataIndex: 'ctesid',
      width: 120,
      render: (val: any, record: any) => (
        <ModalControllerNV
          content={({ setVisible, visible }) => (
            <a
              onClick={() => {
                setVisible(true);
              }}
            >
              {val}
            </a>
          )}
          modal={({ setVisible, visible }) => (
            <ConElemPrefinStepModal
              visible={visible}
              onClose={() => {
                setVisible(false);
              }}
              onSave={(values, action) => {}}
              updatePreFinStep
              record={record}
            />
          )}
        ></ModalControllerNV>
      ),
    },
    {
      dataIndex: 'ctesorder',
      width: 120,
    },

    {
      dataIndex: 'ctesstartdate',
      width: 120,
    },
    {
      dataIndex: 'ctesduration',
      width: 120,
    },
    {
      dataIndex: 'ctesperiodicityunit',
      width: 120,
    },
    {
      dataIndex: 'ctesperiodicity',
      width: 120,
    },
    {
      dataIndex: 'enddate',
      width: 120,
    },
    {
      dataIndex: 'calmethod',
      width: 120,
    },
    {
      dataIndex: 'rateformula',
      width: 120,
    },
    {
      dataIndex: 'ratebasis',
      width: 120,
    },
    {
      dataIndex: 'ratespread',
      width: 120,
      render: (val: number) => toRate(val),
    },
    {
      dataIndex: 'nominalrate',
      width: 120,
      render: (val: number) => toRate(val),
    },
    {
      dataIndex: 'ctesstartamount',
      width: 120,
      render: (val: number) => toCurrency(val),
    },
    {
      dataIndex: 'ctesinterestamount',
      width: 120,
      render: (val: number) => toCurrency(val),
    },
    {
      dataIndex: 'ctesamortizedcoef',
      width: 120,
      render: (val: number) => toRate(val),
    },
    {
      dataIndex: 'ctesamortizedamount',
      width: 120,
      render: (val: number) => toCurrency(val),
    },
    {
      dataIndex: 'ctesrentalamount',
      width: 120,
      render: (val: number) => toCurrency(val),
    },
    {
      dataIndex: 'ctesoutstandingcoef',
      width: 120,
      render: (val: number) => toRate(val),
    },
    {
      dataIndex: 'ctesoutstandingamount',
      width: 120,
      render: (val: number) => toCurrency(val),
    },
  ];

  const calculatePaymentShedulePrefinSteps = (finElement: any) => {
    let FinElemStep = form.getFieldValue('_prefinStepsList') ?? [];

    // calculate FIN
    var finamount = 0;

    const investamount = finElement.cteinvestamount;
    // const firstPayment = finElement.ctefirstpayment;
    // const rvAmount = finElement.ctervamount;
    const upfront = finElement.cteupfrontamount;

    var part = 0;

    const partmethod = finElement.ctepartmethod;

    if (partmethod === 'PROMO' || partmethod === 'REDUCEFIN') {
      part = isNaN(finElement.ctepartamount) ? 0 : finElement.ctepartamount;
    }

    const extracost =
      finElement.cteextracosttofinance == null
        ? 0
        : finElement.cteextracosttofinance;

    finamount = investamount + extracost - upfront - part;

    if (isNil(FinElemStep) || FinElemStep.length === 0) {
      notification.error({
        message: 'Please add steps before',
        description: '',
        duration: 10,
      });
      return;
    } else {
      FinElemStep.forEach((s: ConElemPrefinStepRequest) => {
        s.ctesoutstandingamount = (finamount * s.ctesoutstandingcoef) / 100;
      });

      setLoading(true);
      finEngine
        .calculatePaymentShedulePrefinSteps({
          finReq: {
            elementStep: form.getFieldValue('_prefinStepsList') ?? [],
            inBillingDate: finElement?.ctebilligdate,
            inCalculationMethod: 'STEP',
            inCountingbasis: finElement?.cteratebasis,
            inDeferredMethod: finElement?.ctedeferredinterestmethod,
            inDeferredRate: finElement?.ctedeferredinterestnominalrate,
            inDepositAmount:
              finElement?.ctedepositamount == null
                ? 0
                : finElement?.ctedepositamount,
            inDepositMethod: finElement?.ctedepositinterestmethod,
            inDepositRate:
              finElement?.ctedepositnominalrate == null
                ? 0
                : finElement?.ctedepositnominalrate,

            inFinancedAmount: finamount,
            inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
            inInterestMethod: finElement?.cteinterestmethod,
            inPartAmount:
              finElement?.ctepartamount == null ? 0 : finElement?.ctepartamount,
            inPartMethod: finElement?.ctepartmethod
              ? finElement?.ctepartmethod
              : 'NONE',
            inPartNbDays: form.getFieldValue('ctepartnbdays') ?? 0,
            //finElement?.ctepartdays == null ? 0 : finElement?.ctepartdays,
            inPartRate: form.getFieldValue('ctepartrate') ?? 0,
            inPartInvoicingMode: finElement?.ctepartinvoicingmode,
            //finElement?.ctepartrate == null ? 0 : finElement?.ctepartrate,
            inRatePeriodicity: finElement?.cterateperiodicity,
            inRateType: finElement?.cteratetype,
            inRateValue:
              finElement?.ctenominalrate == null
                ? 0
                : finElement?.ctenominalrate,
            inRoundingAmount: getRounding(finElement.currcode),
            inRoundingRate: 9,
            inStartDate: dateToString(finElement.ctestartdate),
            inTaxcode: finElement?.taxcode,
            inTaxrate: finElement?.taxrate,
            inTaxtype: finElement?.taxtype,
            inTerm: finElement?.ctepaymentterm,
            inUpfrontAmount: finElement?.cteupfrontamount,
          },
        })
        .then((res) => {
          setLoading(false);
          if (res.success) {
            // calculateServAndComm(res, finElement, finamount, inCteid);
            message.success(res.message);

            setFinElement({
              ...finElement,
              conElemSchedules: res.paymentSchedule,
              ctedeferredinterestnominalrate: res.inDeferredRate,
              ctedeferredinterest: res.deferredInterest,
              ctedepositnominalrate: res.inDepositRate,
              ctedepositinterest: res.depositInterest,
              cteactuarialrate: res.effectiverate,
              ctervamount: 0,
              ctervcoef: 0,
              ctefirstpayment: 0,
              ctefirstpaymentcoef: 0,
            });
          } else {
            message.error(res.message);
          }
        })
        .catch((err) => {
          setLoading(false);
        });

      /// end calculate FIN
    }
  }; // end calculate PaymentShedule Steps :

  const handleOk = async (values: any) => {
    // eslint-disable-next-line no-debugger
    //debugger;

    setLoading(true);

    const simpleAsset: any = {
      ...values,
      assetlabel: values.assetlabel,
      assetdescription:
        values.assetdescription === '' || values.assetdescription == null
          ? values.assetlabel
          : values.assetdescription,
      assetcategory: objectParValueToString(values.assetcategory),
      assetcategorylabel: objectLabelToString(values.assetcategory),
      assetfamily: objectParValueToString(values.assetfamily),
      assetfamilylabel: objectLabelToString(values.assetfamily),
      assetsegmentlabel: objectLabelToString(values?.assetsegment),
      assetsegment: objectParValueToString(values?.assetsegment),
      assetclass: 'UC',
      assetComponents: [],
      assetconstructor: '',
      assetconstructorreference: '',
      assetdiscountamount: '',
      assetdiscountperc: '',
      assetgrossamountorigine: '',
      assetgrossamount: form.getFieldValue('assetgrossamount'),
      assetid: Math.floor(_.random(10000) * 1000000),
      assetmodel: objectParValueToString(values?.assetmodel),
      assetnetamount: form.getFieldValue('amountToUse') ?? 0,
      assetnetamountorigine: form.getFieldValue('amountToUse') ?? 0,
      assetpictureurl: '',
      assettype: values.assettype.value,
      assettypelabel: values.assettype.label,
      assetvariant: '',
      catalogid: null,
      catalogstatus: '',
      enddate: '',
      startdate: '',
      suppliername: values.supplier ? values.supplier.tpname : null,
      taxcode: values.taxcode,
      taxrate: 0,
      assetstatus: 'INIT',
      statuslabel: 'Initial',
      assetstatuslabel: 'Initial',
      tpidsupplier: values.supplier ? values.supplier.tpid : null,
      supplierreference: values.supplier ? values.supplier.tpreference : null,
      assetqty: values.assetqty !== undefined ? values.assetqty : 1,
      entityAddAttribut: [],
    };

    setRequestedamount(form.getFieldValue('amountToUse'));

    const asset = assetCatalogToAsset(simpleAsset, [], 1, 0, 'free', []);

    form.setFieldValue('assets', Array(asset));
    const offerList = await getprOfferListByPrcodeAndMgid({
      filters: getFilterList([asset]),
    }).then((res) => {
      return res.list || [];
    });

    if (offerList && offerList?.length > 0) {
      const filteredOffer = offerList[0];
      const filteredAuthDetailList: any[] = tpAuth?.authDetail.filter(
        (authdetail: any) => authdetail.offerid === filteredOffer.offerid
      );
      // setTpAuthDetail(filteredAuthDetailList);

      if (filteredAuthDetailList?.length > 0) {
        const authDetail: any = filteredAuthDetailList[0];

        form.setFieldsValue({
          event: 'tabTpAuthorizationUse',
          authdetailamount: authDetail?.authdetailamount,
          authdetailavailableamount: authDetail?.authdetailavailableamount,
          // amountToUse: e?.authdetailavailableamount,
          authdetailid: authDetail.authdetailid,
          authbookedamount: authDetail?.authbookedamount,
          authdetailusedamount: authDetail?.authdetailusedamount,
          prcodelabel: authDetail?.prcodelabel,
          prcode: authDetail?.prcode,
          offerid: authDetail?.offerid,
          offerlabel: authDetail?.offerlabel,
          ofrtype: authDetail?.ofrtype,
          ofrtypelabel: authDetail?.ofrtypelabel,
          ofridlabel: authDetail?.ofridlabel,
          ofrid: authDetail?.ofrid,
          // tpid: objectid,
          // beneficiaryname: clientName,
          // beneficiaryreference: entityReference,
        });
        await handleOfferChange(
          authDetail.offerid,
          form.getFieldValue('amountToUse')
        );
        setCurrentStep(1);
      } else {
        notification.error({ message: 'Authorization Not Found' });
      }
    }

    form.setFieldValue(
      'assets',
      Array({ ...asset, assetfinamount: form.getFieldValue('amountToUse') })
    );

    if (task) {
      setRequestToSend({
        taskid: task.taskid,
        entity: 'THIRDPARTY',
        entityId: Number(localStorage.getItem('tpid')) ?? 0,
        subentity: 'AUTH',
        subentityId: 0,
        objectreference: '',
        authid: form.getFieldValue('authid'),
        authdetailid: form.getFieldValue('authdetailid'),
        tpidbeneficiairy: form.getFieldValue('tpidbeneficiairy'),
        beneficiaryname: form.getFieldValue('beneficiaryname'),
        beneficiaryreference: form.getFieldValue('authid'),
        amountToUse: form.getFieldValue('amountToUse') ?? 0,
        prcode: form.getFieldValue('prcode'),
        offerid: form.getFieldValue('offerid'),
        ofrid: form.getFieldValue('ofrid'),
        ofrtype: form.getFieldValue('ofrtype'),
        usecomment: asset.chassisno,
        nominalrate: form.getFieldValue('nominalrate'),
        ratespread: form.getFieldValue('ratespread'),
        rateref: form.getFieldValue('rateref'),
        rateformula: form.getFieldValue('rateformula'),
        ratetype: form.getFieldValue('ratetype'),
        calculationtype: form.getFieldValue('calculationtype'),
        periodicity: form.getFieldValue('periodicity'),
        duration: form.getFieldValue('duration'),
        startDate: moment().format('YYYY-MM-DD'),
        endDate: form.getFieldValue('endDate'),
        assets: form.getFieldValue('assets'),
      });
    }
    setLoading(false);
    //;
  };

  const sendRequest = () => {
    setLoading(true);
    const [url, paramsString] = task.serviceurl
      ? task.serviceurl.split('?')
      : ''.split('?');
    // setload(true);
    request
      .post(`${API_URLS.WORKFLOW}/api/${url}`, requestToSend)
      .then((res) => {
        if (res.success) {
          setCurrentStep(2);
          refetch();
          setLoading(false);
          if (res.success) {
            setProcessTerminated(true);
            notification.success({ message: res.message });
          } else {
            return Promise.reject(res);
          }
        } else {
          notification.error({ message: res.message });
        }
      })
      .catch((err) => {
        setLoading(false);
        notification.error({ message: err.message });
      });
  };

  const handleOfferChange = (offerid: number, assetAmount: number) => {
    return getOfferDetailByOfferId({ offerid }).then((res) => {
      if (res.data != null) {
        let calctype = res.data.calculationmethod;
        setOffer({
          prefinnominalrate: res.data.prefinnominalrate,
          upfrontdefault: res.data.upfrontdefault,
          offerid: res.data.offerid,
        });
        form.setFieldsValue({
          duration: res.data.durationdefault,
          periodicity:
            calctype === 'PREFIN'
              ? res.data.prefinperiodicity
              : res.data.periodicity,
          calculationtype: calctype,
          ratetype:
            calctype === 'PREFIN' ? res.data.prefinratetype : res.data.ratetype,
          rateformula:
            calctype === 'PREFIN'
              ? res.data.prefinrateformula
              : res.data.rateformula,
          rateref:
            calctype === 'PREFIN'
              ? res.data.prefinrateref
              : res.data.ratevaluedefault,
          ratespread:
            calctype === 'PREFIN'
              ? res.data.prefinratespreaddefault
              : res.data.ratespreaddefault,
          nominalrate:
            calctype === 'PREFIN'
              ? res.data.prefinnominalrate
              : res.data.ratespreaddefault + res.data.ratevaluedefault,
          amountToUse:
            assetAmount - (assetAmount * res.data?.upfrontdefault) / 100,
          requestAmount: assetAmount,
        });
      }
    });
  };

  // const showDeleteConfirm = () => {
  //   confirm({
  //     title: 'Are you sure to send this request',
  //     icon: <ExclamationCircleFilled />,
  //     content: 'Are you sure to send this request',
  //     okText: 'Yes',
  //     okType: 'primary',
  //     cancelText: 'No',
  //     onOk() {
  //       sendRequest();
  //     },
  //     onCancel() {
  //     },
  //   });
  // };
  const [clicked, setClicked] = useState(false);
  const hide = () => {
    setClicked(false);
  };
  const handleClickChange = (open: boolean) => {
    setClicked(open);
  };
  const content = (
    <Row
      style={{ width: '800px', height: '120px', padding: '15px 0px 0px 15px' }}
    >
      <Col>
        <ExclamationCircleOutlined
          style={{
            marginRight: 10,
            color: 'orange',
            fontSize: '33px',
            float: 'left',
          }}
        />
      </Col>
      <Col style={{ padding: '4px 0px' }}>
        <h3 style={{ fontWeight: 600 }}>
          {' '}
          Are you sure you want to Send this request??
        </h3>
        <span style={{ fontWeight: 600 }}>Note : </span>
        <GetLabel style={{ fontWeight: 600 }} label="text2" />
      </Col>
      <Row gutter={12} style={{ width: '100%' }} justify="end">
        <Col>
          <Button
            type="default"
            htmlType="button"
            comcode="cancel"
            onClick={() => {
              setRequestToSend(null);
              setOffer(null);
              form.resetFields();
            }}
            style={{ height: '30px', margin: '0px 10px', padding: '0px 10px' }}
          />
        </Col>
        <Col>
          <Button
            type="primary"
            htmlType="button"
            onClick={() => {
              sendRequest();
            }}
            loading={loading}
            comcode="ok"
            style={{ height: '30px', margin: '0px 10px', padding: '0px 10px' }}
          />
        </Col>
      </Row>
    </Row>
  );
  const title = (
    <>
      <ExclamationCircleFilled style={{ marginRight: 10, color: 'orange' }} />
      <GetLabel label="text1" />
    </>
  );

  return (
    <DF.Provider pagcode="usedcarfin">
      <Form
        form={form}
        labelCol={{ md: 24 }}
        wrapperCol={{ md: 24 }}
        labelAlign="left"
        layout="vertical"
        size="large"
        onFinish={handleOk}
      >
        <Row justify="center">
          <Col span={22}>
            <Spin size="large" tip="loading ..." spinning={loading}>
              <Card style={{ paddingBottom: 35 }}>
                <Row justify="start">
                  <Title comcode="usedcarfintitle" level={2} color="#243882" />
                </Row>

                <Steps
                  //labelPlacement="vertical"
                  current={currentStep}
                  direction="horizontal"
                  size="default"
                  style={{ marginTop: '35px', marginBottom: '20px' }}
                  // progressDot={isNil(ctrid) ? customDot : false}
                >
                  <Step
                    stepIndex={0}
                    title={
                      <Badge count={form.getFieldValue('assets')?.length ?? 0}>
                        <li style={{ fontSize: '16px' }}>
                          {' '}
                          <GetLabel label="Asset" />{' '}
                        </li>
                      </Badge>
                    }
                    style={{ cursor: 'pointer', fontSize: '16px' }}
                    disabled={currentStep === 2}
                  />

                  <Step
                    stepIndex={1}
                    title={
                      <li>
                        {' '}
                        <GetLabel label="synthese" />{' '}
                      </li>
                    }
                    style={{ cursor: 'pointer' }}
                    disabled={currentStep === 2}
                  />
                  <Step
                    stepIndex={2}
                    title={
                      <li>
                        {' '}
                        <GetLabel label="authInfo" />{' '}
                      </li>
                    }
                    style={{ cursor: 'pointer' }}
                    disabled={currentStep !== 2}
                  />
                </Steps>

                {requestToSend == null ? (
                  <>
                    <Row justify="start">
                      <Title comcode="usedcarfin1" level={4} color="#243882" />
                    </Row>
                    <Row gutter={10}>
                      <UtinaCard
                        level={5}
                        comcode="assetGeneralInformation"
                        style={{ color: '#000' }}
                        lg={15}
                        additionalAttribute
                      >
                        <FormInput
                          col
                          md={24}
                          name="assetlabel"
                          comcode="assetlabel"
                          rules={[{ required: true }]}
                        >
                          <Input />
                        </FormInput>

                        <FormInput
                          col
                          md={12}
                          name="chassisno"
                          comcode="chassisno"
                          rules={[{ required: true }]}
                        >
                          <Input />
                        </FormInput>

                        <FormInput
                          col
                          xs={24}
                          md={12}
                          name="firstregistrationdate"
                          rules={[{ required: false }]}
                        >
                          <DatePicker />
                        </FormInput>

                        <FormInput
                          col
                          xs={24}
                          md={12}
                          name="kilometer"
                          rules={[{ required: false }]}
                        >
                          <InputNumber />
                        </FormInput>
                        <Form.Item shouldUpdate noStyle>
                          {({ getFieldValue }) => (
                            <FormInput
                              col
                              md={12}
                              name="assetsegment"
                              rules={[{ required: true }]}
                              comcode="assetsegment"
                            >
                              <ParListSelectWithLabelInValue
                                parcode="ASSETPRD"
                                onChange={(e) => {
                                  form.setFieldsValue({
                                    assetsegment: e,
                                    assetfamily: '',
                                    assettype: '',
                                    assetcategory: '',
                                    assetmodel: '',
                                  });
                                }}
                              />
                            </FormInput>
                          )}
                        </Form.Item>
                        <Form.Item
                          shouldUpdate={shouldUpdateCompare('assetsegment')}
                          noStyle
                        >
                          {({ getFieldValue }) => (
                            <FormInput
                              col
                              md={12}
                              name="assetfamily"
                              rules={[{ required: true }]}
                            >
                              <ParListSelectWithLabelInValue
                                parcode="ASSETFAM"
                                parvalueparent={objectParValueToString(
                                  getFieldValue('assetsegment')
                                )}
                                onChange={(e) => {
                                  form.setFieldsValue({
                                    assettype: '',
                                    assetcategory: '',
                                    assetmodel: '',
                                  });
                                }}
                              />
                            </FormInput>
                          )}
                        </Form.Item>
                        <Form.Item
                          shouldUpdate={shouldUpdateCompare('assetfamily')}
                          noStyle
                        >
                          {({ getFieldValue }) => (
                            <FormInput
                              col
                              md={12}
                              name="assettype"
                              comcode="assettype"
                              rules={[{ required: true }]}
                            >
                              <ParListSelectWithLabelInValue
                                parcode="ASSETTYPE"
                                disabled={!getFieldValue('assetfamily')}
                                parvalueparent={objectParValueToString(
                                  getFieldValue('assetfamily')
                                )}
                                onChange={(e) => {
                                  form.setFieldsValue({
                                    assettype: e,
                                    assetcategory: '',
                                    assetmodel: '',
                                    assetlabel: e?.label,
                                  });
                                }}
                              />
                            </FormInput>
                          )}
                        </Form.Item>

                        <Form.Item
                          shouldUpdate={shouldUpdateCompare('assettype')}
                          noStyle
                        >
                          {({ getFieldValue }) => (
                            <FormInput
                              col
                              md={12}
                              name="assetcategory"
                              comcode="assetcategory"
                              rules={[{ required: true }]}
                            >
                              <ParListSelectWithLabelInValue
                                parcode="ASSETCAT"
                                disabled={!getFieldValue('assettype')}
                                allowClear
                                parvalueparent={objectParValueToString(
                                  getFieldValue('assettype')
                                )}
                                onChange={(e) => {
                                  form.setFieldsValue({
                                    assetmodel: '',
                                    assetlabel:
                                      getFieldValue(['assettype', 'label']) +
                                        ' ' +
                                        e?.label ?? '',
                                  });
                                }}
                              />
                            </FormInput>
                          )}
                        </Form.Item>

                        <Form.Item
                          noStyle
                          shouldUpdate={shouldUpdateCompare(
                            'assetmulticomponents'
                          )}
                        >
                          {({ getFieldValue, setFieldsValue }) => {
                            return !getFieldValue('assetmulticomponents') ? (
                              <FormInput
                                col
                                xs={24}
                                md={12}
                                name="taxcode"
                                rules={[{ required: true }]}
                              >
                                <TaxSelect
                                  taxflow="INOUT"
                                  onSelected={(tax) => {
                                    form.setFieldsValue({
                                      taxrate: tax?.taxrate ?? 0,
                                    });
                                  }}
                                />
                              </FormInput>
                            ) : null;
                          }}
                        </Form.Item>

                        <Form.Item
                          noStyle
                          shouldUpdate={shouldUpdateCompare([
                            'currcode',
                            'assetmulticomponents',
                            'assetqty',
                            'assetunitnetamount',
                          ])}
                        >
                          {({ getFieldValue }) => {
                            return (
                              <FormInput
                                comcode="assetamount"
                                name="amountToUse"
                                col
                                md={12}
                              >
                                <InputCurrency currcode="" />
                              </FormInput>
                            );
                          }}
                        </Form.Item>
                        <FormInput col xs={24} md={12} name="supplier">
                          <ThirdPartyInput role="SUPPLIER" />
                        </FormInput>
                      </UtinaCard>
                      <UtinaCard
                        level={5}
                        lg={8}
                        comcode="assetPicture"
                        additionalAttribute
                      >
                        <FormInput
                          col
                          xs={24}
                          wrapperCol={{ span: 24 }}
                          labelCol={{ span: 24 }}
                          name="assetpictureurl"
                        >
                          <AssetUpload
                            picid={1}
                            name="assetpictureurl"
                            form={form}
                            objectreference={form.getFieldValue(
                              'assetreference'
                            )}
                          />
                        </FormInput>
                      </UtinaCard>
                    </Row>
                    <Row justify="center" style={{ marginTop: 30 }}>
                      <Button type="primary" htmlType="submit" comcode="send" />
                    </Row>
                  </>
                ) : processTerminated === false ? (
                  <>
                    {/* <div
                      style={{
                        background: '#ebebeb',
                        padding: 20,
                        marginBottom: 50,
                      }}
                    >
                      <Title level={3} comcode="req_accepet" /> */}
                    <Row justify="center">
                      <Title comcode="usedcarfin2" level={3} color="#243882" />
                    </Row>
                    <UtinaCard comcode="req_accepet" level={4}>
                      <Row
                        style={{
                          fontSize: '16px',
                        }}
                      >
                        <Col span={8}>
                          {' '}
                          <GetLabel
                            label="requestedamount"
                            style={{ fontWeight: 'bold', color: '#243882' }}
                          />{' '}
                        </Col>{' '}
                        <Col span={12} style={{ fontWeight: 600 }}>
                          {' '}
                          {toCurrency(requestedamount)}
                        </Col>
                        <Col span={8}>
                          {' '}
                          <GetLabel
                            label="AmountFinanced"
                            style={{ fontWeight: 'bold', color: '#243882' }}
                          />{' '}
                          <span style={{ fontWeight: 'bold', color: 'red' }}>
                            ({100 - offer?.upfrontdefault}%)
                          </span>{' '}
                        </Col>{' '}
                        <Col span={12} style={{ fontWeight: 600 }}>
                          {' '}
                          {toCurrency(
                            form.getFieldValue('amountToUse'),
                            localStorage.getItem('currcode') ?? ''
                          )}
                        </Col>
                        <Col span={8}>
                          {' '}
                          <GetLabel
                            label="Interest"
                            style={{ fontWeight: 'bold', color: '#243882' }}
                          />{' '}
                        </Col>
                        <Col span={12} style={{ fontWeight: 600 }}>
                          {toRate(offer?.prefinnominalrate)}
                        </Col>
                        <Col span={8}>
                          {' '}
                          <GetLabel
                            label="ctepartrate"
                            style={{ fontWeight: 'bold', color: '#243882' }}
                          />{' '}
                        </Col>
                        <Col span={12} style={{ fontWeight: 600 }}>
                          {toRate(form.getFieldValue('ctepartrate'))}
                        </Col>
                        <Col span={8}>
                          {' '}
                          <GetLabel
                            label="ctepartnbdays"
                            style={{ fontWeight: 'bold', color: '#243882' }}
                          />{' '}
                        </Col>
                        <Col span={12} style={{ fontWeight: 600 }}>
                          {form.getFieldValue('ctepartnbdays')}
                        </Col>
                      </Row>

                      <Tabs defaultActiveKey="1" animated>
                        <TabPane tab={<GetLabel label="assets" />} key="1">
                          <Card style={{ padding: 10 }}>
                            <Form.Item shouldUpdate noStyle>
                              {({ getFieldValue }) => {
                                const assets = getFieldValue('assets') ?? [];

                                return (
                                  <Asset
                                    phase="PROD"
                                    form={form}
                                    reftechProp={refetch}
                                    ctrid={contractId}
                                    showActionButton={false}
                                    filtersList={getFilterList(assets)}
                                  />
                                );
                              }}
                            </Form.Item>
                          </Card>
                        </TabPane>
                        <TabPane tab={<GetLabel label="authUse" />} key="2">
                          <Row>
                            <Col span={24}>
                              <Row gutter={30}>
                                <UtinaCard comcode="Summary" level={5} lg={7}>
                                  <FormInput
                                    col
                                    md={24}
                                    name="authdetailamount"
                                  >
                                    <Text>
                                      {toCurrency(
                                        form.getFieldValue('authdetailamount'),
                                        tpAuth?.currcode ??
                                          localStorage.getItem('currcode') ??
                                          ''
                                      )}
                                    </Text>
                                  </FormInput>

                                  <FormInput col md={24} name="nominalrate">
                                    <Value
                                      formatter={(value) => toRate(value)}
                                    />
                                  </FormInput>
                                  <FormInput
                                    col
                                    md={24}
                                    name="authdetailavailableamount"
                                  >
                                    <Value
                                      formatter={(value) =>
                                        toCurrency(
                                          value,
                                          tpAuth?.currcode ??
                                            localStorage.getItem('currcode') ??
                                            ''
                                        )
                                      }
                                    />
                                  </FormInput>
                                  <FormInput
                                    col
                                    md={24}
                                    name="authbookedamount"
                                  >
                                    <Value
                                      formatter={(value) =>
                                        toCurrency(
                                          value,
                                          tpAuth?.currcode ??
                                            localStorage.getItem('currcode') ??
                                            ''
                                        )
                                      }
                                    />
                                  </FormInput>
                                  <FormInput
                                    col
                                    md={24}
                                    name="authdetailusedamount"
                                  >
                                    <Value
                                      formatter={(value) =>
                                        toCurrency(
                                          value,
                                          tpAuth?.currcode ??
                                            localStorage.getItem('currcode') ??
                                            ''
                                        )
                                      }
                                    />
                                  </FormInput>
                                </UtinaCard>
                                <UtinaCard comcode="newUse" level={5} lg={7}>
                                  <Row gutter={8}>
                                    <FormInput col md={24} name="prcode" hidden>
                                      <Input hidden />
                                    </FormInput>

                                    <FormInput col md={24} name="offerlabel">
                                      <Value
                                        value={form.getFieldValue('offerlabel')}
                                      />
                                    </FormInput>

                                    <FormInput col md={24} name="amountToUse">
                                      <Value
                                        formatter={(value) =>
                                          toCurrency(
                                            value,
                                            tpAuth?.currcode ??
                                              localStorage.getItem(
                                                'currcode'
                                              ) ??
                                              ''
                                          )
                                        }
                                      />
                                    </FormInput>

                                    <FormInput col md={24} name="endDate">
                                      <Value />
                                    </FormInput>
                                  </Row>
                                </UtinaCard>
                                <UtinaCard comcode="rate" level={5} lg={7}>
                                  <Row gutter={[8, 8]}>
                                    <FormInput
                                      col
                                      xs={24}
                                      name="calculationtype"
                                    >
                                      <ParListSelect
                                        parcode="CALMETHOD"
                                        disabled
                                      />
                                    </FormInput>
                                    {prefinmethod !== 'PREFINSTEP' ? (
                                      <>
                                        <FormInput
                                          col
                                          xs={24}
                                          name="ratetype"
                                          comcode="ratetype"
                                        >
                                          <ParListSelect
                                            parcode="RATETYPE"
                                            disabled
                                          />
                                        </FormInput>

                                        <FormInput
                                          col
                                          xs={24}
                                          name="rateref"
                                          comcode="rateref"
                                        >
                                          <Value
                                            formatter={() =>
                                              toRate(
                                                form.getFieldValue('rateref')
                                              )
                                            }
                                          ></Value>
                                        </FormInput>
                                        <FormInput
                                          col
                                          xs={24}
                                          name="ratespread"
                                          comcode="ratespread"
                                        >
                                          <Value />
                                        </FormInput>
                                        <FormInput
                                          col
                                          xs={24}
                                          name="nominalrate"
                                          comcode="nominalrate"
                                        >
                                          <Value />
                                        </FormInput>
                                      </>
                                    ) : (
                                      <>
                                        <Form.Item shouldUpdate noStyle>
                                          {({ getFieldValue }) => {
                                            return (
                                              <FormInput
                                                col
                                                xs={24}
                                                md={24}
                                                name="ctepartmethod"
                                                comcode="ctepartmethod"
                                              >
                                                <ParListSelect
                                                  parcode="CTEPARTMET"
                                                  offerid={getFieldValue(
                                                    'offerid'
                                                  )}
                                                  disabled
                                                />
                                              </FormInput>
                                            );
                                          }}
                                        </Form.Item>
                                        <Form.Item shouldUpdate noStyle>
                                          {({ getFieldValue }) => {
                                            return (
                                              <InputCurrency
                                                col
                                                md={24}
                                                disabled
                                                currcode={getFieldValue(
                                                  'currcode'
                                                )}
                                                comcode="ctepartamount"
                                                fieldname="ctepartamount"
                                              />
                                            );
                                          }}
                                        </Form.Item>
                                      </>
                                    )}
                                  </Row>
                                </UtinaCard>
                              </Row>
                            </Col>
                          </Row>
                        </TabPane>

                        {prefinmethod === 'PREFINSTEP' && (
                          <TabPane
                            tab={<GetLabel label="tabprefinsteps" />}
                            key={34}
                          >
                            <Card>
                              <Row justify="end">
                                <Form.Item shouldUpdate noStyle>
                                  {({ getFieldValue }) => {
                                    return (
                                      <FinancialScheduleModal
                                        finElement={finElement}
                                        currcode={getFieldValue('currcode')}
                                        data={getFieldValue('elements')}
                                        comcode="globalSchedule"
                                        loading={loading}
                                        controller={
                                          <ScheduleButton
                                            size="large"
                                            comcode="globalSchedule"
                                            twoToneColor={
                                              isNil(getFieldValue('offerid'))
                                                ? 'gray'
                                                : 'green'
                                            }
                                            disabled={isNil(
                                              getFieldValue('offerid')
                                            )}
                                          ></ScheduleButton>
                                        }
                                      />
                                    );
                                  }}
                                </Form.Item>
                              </Row>
                              <Form.Item shouldUpdate noStyle>
                                {({ getFieldValue }) => {
                                  const _prefinStepsList =
                                    getFieldValue('_prefinStepsList');
                                  return (
                                    <>
                                      <Row justify="end">
                                        <ModalControllerNV
                                          content={({
                                            setVisible,
                                            visible,
                                          }) => (
                                            <ButtonOperation
                                              onClick={() => {
                                                calculatePaymentShedulePrefinSteps(
                                                  finElement
                                                );
                                              }}
                                              htmlType="button"
                                              comcode="calculate"
                                            />
                                          )}
                                          modal={({ setVisible, visible }) => (
                                            <ConElemPrefinStepModal
                                              visible={visible}
                                              onClose={() => {
                                                setVisible(false);
                                              }}
                                              ctesorder={
                                                1 + _prefinStepsList?.length ??
                                                0
                                              }
                                              onSave={(values, action) => {
                                                const newConElemPrefinStepsList: any[] =
                                                  _prefinStepsList ?? [];
                                                newConElemPrefinStepsList?.push();
                                                form.setFieldValue(
                                                  '_prefinStepsList',
                                                  newConElemPrefinStepsList
                                                );
                                              }}
                                              record={undefined}
                                            />
                                          )}
                                        ></ModalControllerNV>
                                      </Row>

                                      <DataGrid
                                        dataSource={_prefinStepsList ?? []}
                                        pagination={false}
                                        columns={columnsPrefinSteps}
                                        titleComcode="conElemPrefinSteps"
                                        rowKey={(e) => e.ctesid}
                                      />
                                    </>
                                  );
                                }}
                              </Form.Item>
                            </Card>
                          </TabPane>
                        )}
                      </Tabs>
                    </UtinaCard>

                    <Row gutter={12}>
                      <Col span={12}>
                        <Button
                          className="btncard"
                          type="default"
                          htmlType="button"
                          comcode="cancel"
                          onClick={() => {
                            setRequestToSend(null);
                            setOffer(null);
                            form.resetFields();
                          }}
                          style={{
                            width: '100%',
                            height: '45px',
                            marginTop: '10px',
                            borderColor: 'red',
                          }}
                        />
                      </Col>
                      <Col span={12}>
                        <Popover
                          style={{ left: '499px', top: ' 219px' }}
                          content={content}
                          title={title}
                          trigger="click"
                          open={clicked}
                          onOpenChange={handleClickChange}
                        >
                          <Button
                            className="btncard"
                            type="primary"
                            htmlType="button"
                            // onClick={() => {
                            //   showDeleteConfirm();
                            // }}
                            loading={loading}
                            comcode="ok"
                            style={{
                              width: '100%',
                              height: '45px',
                              marginTop: '10px',
                            }}
                          />
                        </Popover>
                      </Col>
                    </Row>
                  </>
                ) : (
                  <>
                    <Row justify="start">
                      <GetLabel
                        label="newcarfin3"
                        style={{ color: 'green', fontSize: 23 }}
                      />
                    </Row>
                    <UtinaCard comcode="req_accepet" level={4}>
                      <h2>
                        <span style={{ color: 'red', fontWeight: 'bold' }}>
                          {' '}
                          Note:{' '}
                        </span>{' '}
                        <GetLabel style={{ color: 'green' }} label="text3" />
                      </h2>
                      <Spin spinning={isFetching}>
                        <Row
                          style={{
                            fontSize: '16px',
                          }}
                        >
                          <Col span={8}>
                            {' '}
                            <GetLabel
                              label="authdetailamount"
                              style={{ fontWeight: 'bold', color: '#243882' }}
                            />{' '}
                          </Col>{' '}
                          <Col span={12} style={{ fontWeight: 600 }}>
                            {' '}
                            {toCurrency(tpAuthDetail?.authdetailamount)}
                          </Col>
                          <Col span={8}>
                            {' '}
                            <GetLabel
                              label="authdetailavailableamount"
                              style={{ fontWeight: 'bold', color: '#243882' }}
                            />{' '}
                          </Col>{' '}
                          <Col span={12} style={{ fontWeight: 600 }}>
                            {' '}
                            {toCurrency(
                              tpAuthDetail?.authdetailavailableamount
                            )}
                          </Col>
                          <Col span={8}>
                            {' '}
                            <GetLabel
                              label="aythdetailbookedamount"
                              style={{ fontWeight: 'bold', color: '#243882' }}
                            />
                          </Col>{' '}
                          <Col span={12} style={{ fontWeight: 600 }}>
                            {' '}
                            {toCurrency(tpAuthDetail?.authdetailbookedamount)}
                          </Col>
                          <Col span={8}>
                            {' '}
                            <GetLabel
                              label="authdetailusedamount"
                              style={{ fontWeight: 'bold', color: '#243882' }}
                            />{' '}
                          </Col>
                          <Col span={12} style={{ fontWeight: 600 }}>
                            {toCurrency(tpAuthDetail?.authdetailusedamount)}
                          </Col>
                        </Row>
                      </Spin>
                    </UtinaCard>
                  </>
                )}
              </Card>
            </Spin>
          </Col>
        </Row>

        <Modal
          title={
            <GetLabel
              style={{ fontSize: 18, paddingLeft: 10 }}
              label="altertitle"
            />
          }
          centered
          open={open === 1}
          width={600}
          footer={null}
          // onCancel={() => setOpen(2)}
          closeIcon={
            <CloseOutlined
              onClick={() => {
                setOpen(2);
              }}
            />
          }
        >
          <div style={{ padding: 3 }}>
            <Badge.Ribbon text="Info" color="orange">
              <Card title=" " size="small">
                <Row justify="space-between">
                  <Col>
                    <GetLabel
                      style={{ fontSize: 18 }}
                      label="textvailableamount"
                    />
                  </Col>
                  <Col style={{ fontSize: 18 }}>
                    {' '}
                    <b>
                      {toCurrency(tpAuthDetail?.authdetailavailableamount ?? 0)}
                    </b>
                  </Col>
                </Row>
              </Card>
            </Badge.Ribbon>
          </div>
        </Modal>
      </Form>
    </DF.Provider>
  );
};

type UseOfferListParams = {
  catalogid?: number;
  duration?: number;
  filtersList?: prFilteringCriteria;
  filters?: string;
  finamount?: number;
  prcode?: string;
  searchMode: string; // PRCODE : by prcode, CATALOG : bu Catalog, FIN : by FinaMount and Duration
};

export default withRouter(UsedCarFin);
